import React__default from 'react';
import { useDimensions } from '../../../hooks/useDimensions.es.js';

const tooltip = "_tooltip_yyp1f_9";
const tooltipOpen = "_tooltip-open_yyp1f_1";
const content = "_content_yyp1f_84";
const styles = {
	tooltip: tooltip,
	tooltipOpen: tooltipOpen,
	content: content
};

const singleLineHeightPlusPadding = 28;
const Tooltip = ({ children, allowMultiline = false, "aria-hidden": ariaHidden = void 0, id = void 0, position = "south", zIndex = 2 }) => {
  const [ref, { height }] = useDimensions();
  const isMultiline = height > singleLineHeightPlusPadding;
  return React__default.createElement(
    "span",
    { "aria-hidden": ariaHidden, className: styles.tooltip, "data-testid": `tooltip-${position}`, "data-position": position, "data-multiline": isMultiline, "data-allow-multiline": allowMultiline, "data-zds": true, id, ref, role: "tooltip", style: { zIndex } },
    React__default.createElement("span", { className: styles.content, "data-multiline": allowMultiline, "data-zds": true }, children)
  );
};
const TooltipPositionStyles = {
  northwest: { bottom: `calc(100% + var(--zds-space-2))`, left: 0 },
  north: {
    bottom: `calc(100% + var(--zds-space-2))`,
    left: "50%",
    transform: "translateX(-50%)"
  },
  northeast: { bottom: `calc(100% + var(--zds-space-2))`, right: 0 },
  east: {
    left: `calc(100% + var(--zds-space-2))`,
    top: "50%",
    transform: "translateY(-50%)"
  },
  southeast: { top: `calc(100% + var(--zds-space-2))`, right: 0 },
  south: {
    top: `calc(100% + var(--zds-space-2))`,
    left: "50%",
    transform: "translateX(-50%)"
  },
  southwest: { top: `calc(100% + var(--zds-space-2))`, left: 0 },
  west: {
    right: `calc(100% + var(--zds-space-2))`,
    top: "50%",
    transform: "translateY(-50%)"
  }
};

export { Tooltip, TooltipPositionStyles };
//# sourceMappingURL=Tooltip.es.js.map
